export default __webpack_public_path__ + "static/media/bannersweb_RW_coche_moto_500_330x330.24d3caab.jpg";